import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AUTH_SERVICE_TOKEN, AuthService } from '../service';

/**
 * Allows a route only for visitors who are NOT logged in (e.g. the public company
 * registration / success / error pages). Logged-in advisors are redirected to the dashboard.
 */
export const unauthenticatedOnlyGuard: CanActivateFn = (): boolean | UrlTree => {
  const authService = inject<AuthService>(AUTH_SERVICE_TOKEN);
  const router = inject(Router);

  return authService.loggedIn ? router.createUrlTree(['/dashboard']) : true;
};
